import { render } from "./MerchantCustomerDetailsPage.vue?vue&type=template&id=592b67e0&ts=true"
import script from "./MerchantCustomerDetailsPage.vue?vue&type=script&lang=ts"
export * from "./MerchantCustomerDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__